<template>
  <div class="employeeslist">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">
                  Administrative Line Manager ({{
                    employees[0].manager.firstName +
                      " " +
                      employees[0].manager.lastName
                  }})
                </h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Managers</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" data-toggle="modal" @click="openDialog()"
                  ><i class="fa fa-plus"></i> Map Employee</a
                >
                <a
                  class="btn add-btn mx-2"
                  data-toggle="modal"
                  @click="openIIDialog()"
                  ><i class="fa fa-plus"></i> Add as Level 2 Approver</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  v-model="filterEmpId"
                  @keyup="employeeCode"
                  type="text"
                  class="form-control floating"
                  style="height: 55px !important;"
                />
                <label class="focus-label">Employee ID</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  v-model="filterEmpName"
                  @keyup="looksearch"
                  class="form-control floating"
                  style="height: 55px !important;"
                />
                <label class="focus-label">Employee Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group form-focus select-focus">
                <multiselectvue
                  class="from-control"
                  v-model="newEmployeeDesignation"
                  placeholder="Select Designation"
                  :custom-label="nameOfDesignation"
                  :options="sortedEmployeeDesignation"
                  :searchable="true"
                  @select="optionSelectDesignation"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{
                    option.name
                  }}</template>
                </multiselectvue>
                <!-- <select
                  class="form-control"
                  style="height: 55px !important;"
                  v-model="filterDesignationId"
                >
                  <option>Select Designation</option>
                  <option
                    v-for="item in sortedEmployeeDesignation"
                    :key="item.id"
                    :value="parseInt(item.id)"
                    >{{ item.name }}</option
                  >
                </select>
                <label class="focus-label">Designation</label> -->
              </div>
            </div>
            <div class="col-sm-6 col-md-2" style="height: 60px !important;">
              <div class="form-group form-focus select-focus">
                <!-- <select
                  class="form-control"
                  style="height: 55px !important;"
                  v-model="filterDepartmentId"
                  @change="searchDepart"
                >
                  <option>Select Department</option>
                  <option
                    v-for="item in departments"
                    :key="item.id"
                    :value="parseInt(item.id)"
                    >{{ item.name }}</option
                  >
                </select> -->

                <multiselectvue
                  class="from-control"
                  v-model="selectDeparment"
                  placeholder="Select Department"
                  :custom-label="nameOfRank"
                  :options="sortedDepartment"
                  :searchable="true"
                  @select="optionSelectRank"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{
                    option.name
                  }}</template>
                </multiselectvue>
                <!-- <label class="focus-label">Department</label> -->
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <a href="#" @click="getFilter" class="btn btn-success btn-block">
                Search
              </a>
            </div>
          </div>
          <!-- /Search Filter -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="searchEmployeeList"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar">
                      <div class="avatar">
                        <img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"
                        />
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                        />
                      </div>
                      <div v-if="item.status == 3">
                        <p>
                          {{
                            item.employee.firstName +
                              " " +
                              item.employee.lastName
                          }}
                        </p>
                        <span>{{ item.employee.designation.name }}</span>
                      </div>
                      <div v-else>
                        {{
                          item.employee.firstName + " " + item.employee.lastName
                        }}
                        <span>{{ item.employee.designation.name }}</span>
                      </div>
                    </h2>
                  </template>
                  <template v-slot:[`item.joinDate`]="{ item }">
                    {{
                      item.joinDate
                        ? new Date(item.joinDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->

          <v-dialog v-model="modalDialog" max-width="725px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Profile Information</h5>
                <button type="button" class="close" @click="closeDialog()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="addManager">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                        v-if="message"
                      >
                        <strong>Success!</strong> {{ message }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Employee</label>

                        <multiselectvue
                          class="from-control"
                          v-model="employee"
                          placeholder="Select Employee"
                          :custom-label="nameOfEmployee"
                          :options="sortedEmployeeNames"
                          :searchable="true"
                          @select="optionSelected"
                          :allow-empty="false"
                        >
                          <template slot="singleLabel" slot-scope="{ option }"
                            >{{ option.firstName }}
                            {{ option.lastName }}</template
                          >
                        </multiselectvue>

                        <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
                      </div>
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <v-dialog v-model="modalIIDialog" max-width="725px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Assign Employee</h5>
                <button type="button" class="close" @click="closeIIDialog()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="addIIManager">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                        v-if="message"
                      >
                        <strong>Success!</strong> {{ message }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Employee</label>

                        <multiselectvue
                          class="from-control"
                          v-model="employee"
                          placeholder="Select Employee"
                          :custom-label="nameOfEmployee"
                          :options="sortedEmployeeNames"
                          :searchable="true"
                          @select="optionSelected"
                          :allow-empty="false"
                        >
                          <template slot="singleLabel" slot-scope="{ option }"
                            >{{ option.firstName }}
                            {{ option.lastName }}</template
                          >
                        </multiselectvue>

                        <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
                      </div>
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      company: authenticationService.currentOfficeValue,
      managerId: this.$route.params.id,
      modalDialog: false,
      modalIIDialog: false,
      employeeId: 0,
      employee: "",
      employees: [],
      allemployees: [],
      nofilterEmployees: [],
      designations: [],
      media: "data:image/jpeg;base64,",
      ranks: null,
      departments: [],
      submitted: false,
      loading: false,
      selectDeparment: "",
      newEmployeeDesignation: "",
      error: "",
      message: "",
      filterDesignationId: "",
      filterEmpName: "",
      filterEmpId: "",
      filterDepartmentId: "",
      newData: [],

      headers: [
        {
          text: "Name",
          align: "start",
          value: "profile",
          sortable: false
        },

        { text: "Employee Code", value: "employee.employeeCode" },
        { text: "Bus. Unit", value: "employee.companyUnit.name" },
        { text: "Email", value: "employee.email" },
        { text: "Mobile", value: "employee.phone" },
        { text: "Join Date", value: "joinDate" },
        { text: "Gender", value: "employee.gender" }
      ]
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    rankId: { required },
    //address: { required },
    phone: { required },
    email: { required },
    designationId: { required }
  },

  computed: {
    searchEmployeeList: function() {
      return this.employees.filter(
        d =>
          d.firstName
            .toLowerCase()
            .includes(this.filterEmpName.toLowerCase()) ||
          d.lastName.toLowerCase().includes(this.filterEmpName.toLowerCase())
      );
    },

    searchEmployeeList: function() {
      function compare(a, b) {
        if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) return -1;
        if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) return 1;
        return 0;
      }

      return this.newData.sort(compare);
    },

    sortedEmployeeDesignation: function() {
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }

      return this.designations
        ? this.designations.sort(compare)
        : this.designations;
    },
    sortedDepartment: function() {
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }

      return this.departments
        ? this.departments.sort(compare)
        : this.departments;
    },
    sortedEmployeeNames: function() {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.allemployees.sort(compare);
    }
  },

  methods: {
    nameOfEmployee({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },

    optionSelected(option, id) {
      console.log(option.id);
      this.employeeId = option.id;
    },
    addManager() {
      var req = { managerId: this.managerId, employeeId: this.employeeId };

      this.loading = true;
      employeeService.addEmployeeManager(req).then(
        id => {
          this.message = "Employee Mapped successfully";
          employeeService.getManager(this.managerId).then(
            model => {
              (this.employees = model), (this.nofilterEmployees = model);

              this.newData = model.map(c => {
                return {
                  ...c,
                  fullName: c.employee.firstName + " " + c.employee.lastName
                };
              });
              this.nofilterEmployees = model.map(c => {
                return {
                  ...c,
                  fullName: c.employee.firstName + " " + c.employee.lastName
                };
              });

              console.log(this.newData);
            },

            error => {
              this.error = error;
            }
          );
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    addIIManager() {
      var req = { managerId: this.managerId, employeeId: this.employeeId };

      this.loading = true;
      employeeService.addEmployeeManagerII(req).then(
        id => {
          this.message =
            "Added as a level 2 approver and Employee Mapped successfully";
          employeeService.getManager(this.managerId).then(
            model => {
              (this.employees = model), (this.nofilterEmployees = model);

              this.newData = model.map(c => {
                return {
                  ...c,
                  fullName: c.employee.firstName + " " + c.employee.lastName
                };
              });
              this.nofilterEmployees = model.map(c => {
                return {
                  ...c,
                  fullName: c.employee.firstName + " " + c.employee.lastName
                };
              });

              console.log(this.newData);
            },

            error => {
              this.error = error;
            }
          );
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    nameOfDesignation({ name }) {
      return `${name}`;
    },

    optionSelectDesignation(option, id) {
      console.log(option.id, this.newEmployeeDesignation.id);
      this.filterDesignationId = option.id;
    },

    nameOfRank({ name }) {
      return `${name}`;
    },

    optionSelectRank(option, id) {
      console.log(option.id, this.selectDeparment.id);
      this.filterDepartmentId = option.id;
    },
    getFilter() {
      // console.log(this.employees.designation.departmentId);
      this.employees = this.nofilterEmployees;
      var employee = [];
      if (this.filterEmpId != "") {
        this.newData = this.nofilterEmployees.filter(
          c =>
            c.employee.employeeCode != null &&
            c.employee.employeeCode
              .toLowerCase()
              .match(this.filterEmpId.toLowerCase())
        );
      }
      if (this.filterEmpName != "" && this.filterDesignationId != "") {
        this.newData = this.nofilterEmployees.filter(
          c =>
            this.filterEmpName
              .toLowerCase()
              .match(c.employee.firstName.toLowerCase()) ||
            this.filterEmpName
              .toLowerCase()
              .match(c.employee.lastName.toLowerCase()) ||
            c.employee.designationId == parseInt(this.filterDesignationId)
        );
      }
      if (this.filterEmpName != "" && this.filterDepartmentId != "") {
        this.newData = this.nofilterEmployees.filter(
          c =>
            this.filterEmpName
              .toLowerCase()
              .match(c.employee.firstName.toLowerCase()) ||
            this.filterEmpName
              .toLowerCase()
              .match(c.employee.lastName.toLowerCase()) ||
            c.employee.designation.departmentId ==
              parseInt(this.filterDepartmentId)
        );
      }

      if (this.filterEmpName != "" && this.filterDesignationId == "") {
        this.newData = this.nofilterEmployees.filter(c =>
          c.employee.fullName
            .toLowerCase()
            .includes(this.filterEmpName.toLowerCase())
        );
      }
      if (this.filterDesignationId != "") {
        this.newData = this.nofilterEmployees.filter(
          c => c.employee.designationId == parseInt(this.filterDesignationId)
        );
      }
      if (this.filterDepartmentId != "") {
        this.newData = this.nofilterEmployees.filter(c => {
          if (c.designation.departmentId == this.filterDepartmentId) {
            c.designation.departmentId == parseInt(this.filterDepartmentId);
            console.log("found");
          }
          // console.log(c.designation);
        });
        console.log("click");
      }
      if (
        this.filterEmpId == "" &&
        this.filterEmpName == "" &&
        this.filterDesignationId == "" &&
        this.filterDepartmentId
      ) {
        this.newData = this.nofilterEmployees;
      }
    },

    looksearch() {
      this.newData = this.nofilterEmployees.filter(c =>
        c.employee.fullName
          .toLowerCase()
          .includes(this.filterEmpName.toLowerCase())
      );
    },
    employeeCode() {
      this.newData = this.nofilterEmployees.filter(
        c =>
          c.employee.employeeCode != null &&
          c.employee.employeeCode
            .toLowerCase()
            .match(this.filterEmpId.toLowerCase())
      );
    },
    GetDesignations() {
      organizationService.getDesignations().then(
        model => {
          this.designations = model;
          console.log(this.designations);
        },
        error => {
          this.error = error;
        }
      );
    },
    GetRanks() {
      organizationService.getRanks().then(
        model => {
          this.ranks = model;
        },
        error => {
          this.error = error;
        }
      );
    },

    GetDepartments() {
      organizationService.getDepartments().then(
        model => {
          this.departments = model;
          console.log(this.departments);
        },
        error => {
          error = error;
        }
      );
    },
    GetMapEmployees() {
      employeeService.getManager(this.managerId).then(
        model => {
          (this.employees = model), (this.nofilterEmployees = model);

          this.newData = model.map(c => {
            return {
              ...c,
              fullName: c.employee.firstName + " " + c.employee.lastName
            };
          });
          this.nofilterEmployees = model.map(c => {
            return {
              ...c,
              fullName: c.employee.firstName + " " + c.employee.lastName
            };
          });

          console.log(this.newData);
        },

        error => {
          this.error = error;
        }
      );
    },
    openDialog() {
      this.modalDialog = true;
    },
    closeDialog() {
      this.modalDialog = false;
    },
    openIIDialog() {
      this.modalIIDialog = true;
    },
    closeIIDialog() {
      this.modalIIDialog = false;
    },
    GetEmployees() {
      employeeService.getAllEmployees(this.company.id).then(
        model => {
          this.allemployees = model;
        },
        error => {
          this.error = error;
        }
      );
    }
  },
  mounted() {
    this.GetRanks();
    this.GetDesignations();
    this.GetMapEmployees();
    this.GetEmployees();
    this.GetDepartments();
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "employeeslist"
};
</script>



// WEBPACK FOOTER //
// src/components/employees/manager.vue